<template>
  <div class="flex max-w-lg flex-col items-center gap-4 text-red-40">
    <h3 class="font-headline text-7xl font-normal">
      Å nei,
    </h3>
    <p class="text-3xl">
      0 treff.
    </p>
    <p v-if="$slots.default" class="text-3xl">
      <slot />
    </p>
    <StaticAsset
      folder="graphics"
      file="fallback_noresults.png"
      aria-hidden="true"
      class="mt-4"
    />
  </div>
</template>
